/**
 * Topbar notifications bell view-model — pure shaping (badge text, type -> icon /
 * label key / target route, optimistic mark-read). Plain CommonJS so node:test can
 * cover it; the bell component just binds the output.
 * Contract: GET /notifications, GET /notifications/unread-count -> { count },
 * PATCH /notifications/:id/read, PATCH /notifications/read-all -> { updated }.
 */
var TYPE_META = {
  'claim.created': { icon: 'note_add', route: 'claims' },
  'claim.decided': { icon: 'gavel', route: 'claims' },
  'claim.status_changed': { icon: 'sync_alt', route: 'claims' },
  'report.ready': { icon: 'bar_chart', route: 'reports' },
  'ai.job_error': { icon: 'error_outline', route: null },
};

function typeMeta(type) {
  return TYPE_META[type] || { icon: 'notifications', route: null };
}

/** Badge text: '' for 0/invalid, the number up to 99, then '99+'. */
function badgeText(count) {
  var n = Math.floor(Number(count));
  if (!isFinite(n) || n <= 0) return '';
  return n > 99 ? '99+' : String(n);
}

/** Safe count from the unread-count payload. */
function parseCount(payload) {
  var n = Number(payload && payload.count);
  return isFinite(n) && n > 0 ? Math.floor(n) : 0;
}

/** Items from the §1 list envelope (or []). */
function parseList(payload) {
  return (payload && Array.isArray(payload.data) && payload.data) || [];
}

/** Route location for a notification (claim -> claims, report -> reports) or null. */
function targetFor(n) {
  var meta = typeMeta(n && n.type);
  if (!meta.route) return null;
  var loc = { name: meta.route };
  if (meta.route === 'claims' && n.data && n.data.claimId != null) loc.query = { claim: String(n.data.claimId) };
  return loc;
}

/** Report-ready notifications carry data.failed when generation failed. */
function isFailure(n) {
  return !!(n && (n.type === 'ai.job_error' || (n.data && n.data.failed)));
}

/** Return a new list with item `id` marked read (immutable; no-op if unknown). */
function markRead(items, id, nowIso) {
  return (items || []).map(function (n) {
    if (String(n.id) !== String(id) || n.read) return n;
    return Object.assign({}, n, { read: true, readAt: nowIso || n.readAt || null });
  });
}

function markAllRead(items, nowIso) {
  return (items || []).map(function (n) {
    return n.read ? n : Object.assign({}, n, { read: true, readAt: nowIso || null });
  });
}

/** New unread count after marking one item read (never below 0). */
function decrement(count, wasUnread) {
  return wasUnread ? Math.max(0, (Number(count) || 0) - 1) : Number(count) || 0;
}

module.exports = {
  TYPE_META: TYPE_META,
  typeMeta: typeMeta,
  badgeText: badgeText,
  parseCount: parseCount,
  parseList: parseList,
  targetFor: targetFor,
  isFailure: isFailure,
  markRead: markRead,
  markAllRead: markAllRead,
  decrement: decrement,
};
